<!--
 * @Description: 医院指南
 * @Date: 2023-05-15 15:08:44
 * @LastEditTime: 2023-05-19 23:17:32
-->

<template>
  <div class="hospital-guide">
    <common-title
      :title="title"
      :sub-title="subTitle"
      :is-more="true"
      :more-text="moreText"
      @on-more-click="onMoreClick"
    />
    <div class="list-wrap">
      <cube-scroll
        ref="scroll"
        :data="hospitalList"
        direction="horizontal"
        class="horizontal-scroll-list-wrap"
        :class="{ 'only-one': hospitalList.length < 2 }"
      >
        <ul class="list-wrapper">
          <li
            v-for="item in hospitalList"
            :key="item.hospital_id"
            class="list-item"
            @click="onHospitalClick(item)"
          >
            <div class="title">
              <img :src="item.logo" />
              <p>{{ item.name }}</p>
            </div>
            <ul class="tag-list">
              <li v-if="item.rank_tag">{{ item.rank_tag }}</li>
              <li>医生:{{ item.doctor_count }}位</li>
            </ul>
          </li>
        </ul>
      </cube-scroll>
    </div>
  </div>
</template>

<script>
import CommonTitle from './CommonTitle.vue';

export default {
  components: {
    CommonTitle,
  },
  props: {
    title: {
      type: String,
      default: () => '医院指南',
    },
    // 医院列表
    hospitalList: {
      type: Array,
      default: () => [],
    },
    // 副标题
    subTitle: {
      type: String,
      default: () => '',
    },
    // 更多字段
    moreText: {
      type: String,
      default: () => '',
    },
  },
  methods: {
    /**
     * 点击查看更多
     */
    onMoreClick() {
      this.$emit('on-more-click');
    },
    /**
     * 点击医院卡片
     *
     * @param {string} hospital_id 医院id
     */
    onHospitalClick({ name }) {
      this.$emit('on-hospital-click', name);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
.hospital-guide {
  width: 100%;
  margin: rem(10) auto 0;
  background: #fff;
  border-radius: rem(6);

  .list-wrap {
    padding: rem(10) 0 rem(10) rem(10);
    .list-item {
      width: rem(204);
      height: rem(79);
      margin-right: rem(7);
      padding: rem(10);
      background: #fafafa;
      border-radius: rem(4);
      &:last-child {
        margin-right: rem(10);
      }
      .title {
        display: flex;
        align-items: center;
        height: rem(27);
        p {
          width: rem(140);
          max-height: rem(31);
          font-size: 12px;
          white-space: initial;
          @include multiple-ellipsis;

          text-align: left;
        }
      }
      img {
        width: rem(29);
        height: rem(29);
        margin-right: rem(7);
        border-radius: rem(20);
      }
    }
    .tag-list {
      display: flex;
      align-items: center;
      width: 100%;
      height: rem(25);
      margin-top: rem(10);
      padding: 0 rem(2);
      overflow-x: auto;
      color: #1cc381;
      font-size: rem(12);
      line-height: rem(14);
      text-align: justify;
      li {
        box-sizing: content-box;
        height: rem(22);
        margin-right: rem(5);
        padding: 0 rem(8);
        line-height: rem(22);
        // border: rem(1) solid #1cc381;
        // border-radius: rem(2);
        @include border-1px(#1cc381, 4);
      }
    }
  }
}
::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
::v-deep {
  .horizontal-scroll-list-wrap {
    &.only-one {
      > div {
        width: 100%;
        ul {
          text-align: left;
        }
      }
    }

    .cube-scroll-content {
      display: inline-block;
    }
    .list-wrapper {
      white-space: nowrap;
    }
    .list-item {
      display: inline-block;
    }
  }
}
</style>
